import { Form, Input, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['CheckSensitiveEnabled', 'CheckSensitiveOnPromptEnabled', 'SensitiveWords']

export default function SensitiveWordsSection({ options }: { options: OptionsAPI }) {
  const { get, getBool, patch } = options

  return (
    <SettingSectionCard title="敏感词过滤" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="启用敏感词检测">
            <Switch checked={getBool('CheckSensitiveEnabled')} onChange={(v) => patch({ CheckSensitiveEnabled: v })} />
          </Form.Item>
          <Form.Item label="检测用户 Prompt">
            <Switch
              checked={getBool('CheckSensitiveOnPromptEnabled')}
              onChange={(v) => patch({ CheckSensitiveOnPromptEnabled: v })}
            />
          </Form.Item>
        </div>
        <Form.Item label="敏感词列表" extra="一行一个，不区分大小写">
          <Input.TextArea
            value={get('SensitiveWords')}
            onChange={(v) => patch({ SensitiveWords: v })}
            autoSize={{ minRows: 6, maxRows: 12 }}
          />
        </Form.Item>
      </Form>
    </SettingSectionCard>
  )
}
